export class DocumentBundleApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async validateBundleGeneration({ loanIdOrLegacyLoanNumber, documentBundleTypeId }) {
    return this.#http.get(
      `/DocumentBundle/${loanIdOrLegacyLoanNumber}/${documentBundleTypeId}/validate`,
    );
  }

  async getBundle({ loanIdOrLegacyLoanNumber, documentBundleTypeId, separateFiles = false }) {
    return this.#http.get(`/DocumentBundle/${loanIdOrLegacyLoanNumber}/${documentBundleTypeId}`, {
      params: { separateFiles },
      responseType: 'blob',
    });
  }
}
